// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ki-0";
export var fileCarousel = "_ki-2";
export var removeFileButton = "_ki-1";